export default __webpack_public_path__ + "static/media/my_journey_part2_3.3ca80606.png";